<template>
	<form id="add-domain-form" novalidate class="needs-validation" :class="{'was-validated':hasError}" v-on:submit.prevent="saveForm">

		<error :error="error"></error>

		<div class="form-row">
			<div class="col-sm-6">
				<div class="m-t pl-3 pr-3 form-group required">
					<label class="control-label required font-weight-bold" for="industry-select">Industry</label>
					<select id="industry-select" class="form-control custom-select" v-model="industry">
						<option value="10">Energy</option>
						<option value="15">Materials</option>
						<option value="20">Industrials</option>
						<option value="25">Consumer Discretionary</option>
						<option value="30">Consumer Staples</option>
						<option value="35">Health Care</option>
						<option value="40">Financials</option>
						<option value="45">Information Technology</option>
						<option value="50">Telecommunication Services</option>
						<option value="55">Utilities</option>
						<option value="60">Real Estate</option>
					</select>
				</div>
			</div>
			<div class="col-sm-6">
				<div class="m-t pl-3 pr-3 form-group required">
					<label class="control-label required font-weight-bold" for="user-total-input">User Total</label>
					<input id="user-total-input" class="form-control" :class="{'is-invalid':totalError.length}" maxlength="8" size="8" placeholder="" v-model="userTotal"/>
					<div class="invalid-feedback" v-if="totalError">{{totalError}}</div>
				</div>
			</div>
		</div>
	
		<div class="clearfix mt-1 mb-3">
			<div class="float-left ml-3">
				
			</div>
			<div class="float-right mr-3">
				<button type="submit" class="btn btn-outline-primary px-3">Update</button>
				<button type="button" class="btn btn-outline-primary px-3" @click="closeForm">Cancel</button>
			</div>
		</div>

	</form>
</template>

<script>
	import Error from './Error'

	import api from '../api'
	import store from '../state'
	import router from '../router'

	export default {
		name: 'EditDomainForm',
		components: {Error},
		props: ['domain','industry','userTotal'],
		data() {
			return {
				error: '',
				totalError:''
			}
		},
		methods: {
			closeForm() {
				this.$emit('close-edit-domain');
			},
			async saveForm() {
				
				//Do any validation
				this.totalError = '';

				if (!this.userTotal || !this.isNumeric(this.userTotal) || this.userTotal < 1) this.totalError = 'Please enter valid number of users in organisation';				
				if (this.hasError) return;

				try
				{
					var response = await api.put('domain', {value:this.domain, industry:parseInt(this.industry), total:parseInt(this.userTotal)});	
					store.dispatch('getDomainsAsync');
					this.closeForm();
				}
				catch(err) {
					this.error = err + ""; //Get the string representation of the error		
				}
			},
			isNumeric(value) {
				return /^\d+$/.test(value);
			}
		},
		computed: {
			hasError() {
				return (!!this.totalError);
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/EditDomainForm.vue